import React from "react"

import BlockContent from "@sanity/block-content-to-react"
import { Serializers } from "./serializers.js"

export const PortableTextBlock = ({ text, ...props }) => {
  return <BlockContent blocks={text} serializers={Serializers} {...props} />
}
